/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';

import { Icons } from '../../../bphComponents/bundle';
import COLORS from '../../styles/Colors';

const TripleStateSelectionIcon = (props) => {
  switch (props.viewState) {
    case 'checked':
      return <Icons.IconCheckmarkCircle.Large32 color={COLORS.gsLightest} backgroundColor={props.color} />
    case 'partial':
      return <Icons.IconCircleDash.Large32 color={props.color} backgroundColor={COLORS.gsLightest} />
    case 'empty':
    default:
      return <Icons.IconCircle.Large32 color={props.color} fillColor={COLORS.gsLightest} />
  }
};

TripleStateSelectionIcon.propTypes = {
  viewState: PropTypes.oneOf(['checked', 'empty', 'partial']),
  color: PropTypes.string,
};

export default TripleStateSelectionIcon;
